import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base-service';
import { SalesOrderModal } from '../modal/sales-order-modal';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';
import { Observable } from 'rxjs';
import { ResponseData } from '../../../core/modal/base-save-update-response';
import { PartyModal } from '../../party/modal/party-modal';
import { environment } from '../../../../environments/environment';
import { Organization } from '../../purchase-order/modal/organization';
import { PaginationData } from '../../../core/modal/pagination-data';
import { OrderingData } from '../../../core/modal/ordering-data';
import { saveAs } from 'file-saver';
import { SOPrintModal } from '../sales-order-print/sales-order-print.component';
import { SOMailModel } from '../modal/so-mail-model';
import { SearchData } from '../../../core/modal/search-data';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderServiceService extends BaseService<SalesOrderModal> {
  public getAllByPartner = '/getAllByPartner';
  pagination: { pageIndex: number; perPage: number };
  pageTotalLength = 0;
  serverFilterObj: SearchData[] = [];
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'chemical/salesOrder';
  }

  validate(): boolean {
    return false;
  }

  public sendMailOnSave(mailDto: any) {
    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + 'chemical/salesOrder/sendSoToMail';
    return this.http.post(url, mailDto, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
    });
  }

  getSoPrint(reqDto: SOPrintModal) {
    var fileName = 'SalesOrder';
    if (reqDto && reqDto.soNo) {
      var fileName = reqDto.soNo;
    }

    var mediaType = 'application/pdf';
    let url = environment.SERVER_URL + 'chemical/salesOrder/pdf';
    this.http.post(url, reqDto, { responseType: 'blob' }).subscribe((response) => {
      var blob = new Blob([response], { type: mediaType });
      saveAs(blob, fileName + '.pdf');
    });
  }

  public getOrganizationList(): Observable<ResponseData<Organization>> {
    return this.http.get<ResponseData<Organization>>(environment.SERVER_URL + 'organization' + this.getAllByPartner);
  }

  public getAllFilterList(url: string): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(environment.SERVER_URL + url);
  }

  getAll(paginationData: PaginationData, orderingData: OrderingData): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<SalesOrderModal>>(environment.SERVER_URL + 'chemical/salesOrder/getByStaff');
  }

  public getSoNumber(): Observable<ResponseData<string>> {
    return this.http.get<ResponseData<string>>(environment.SERVER_URL + this.getModuleName() + '/getSOUniqueID');
  }
  public sendMail(mailDto: SOMailModel) {
    return this.http.post<ResponseData<SOMailModel>>(
      environment.SERVER_URL + this.getModuleName() + '/sendMail',
      mailDto
    );
  }

  getAllByPagination(param): Observable<ResponseData<SalesOrderModal>> {
    return this.http.post<ResponseData<SalesOrderModal>>(environment.SERVER_URL + this.getModuleName(), param);
    // }
  }

  getServerFilterObj() {
    return this.serverFilterObj;
  }

  public getPrintParameters(param): Observable<ResponseData<any>> {
    return this.http.post<ResponseData<any>>(environment.SERVER_URL + 'chemical/printParameter/saveAll', param);
  }

  public getByModuleNameAndEntityId(id): any {
    return this.http.get(
      environment.SERVER_URL + 'chemical/printParameter/getByModuleNameAndEntityId/SalesOrder/' + id
    );
  }

  setServerFilterObj(filters: SearchData[]) {
    let filterObj = JSON.parse(JSON.stringify(filters));

    if (filterObj && filterObj.length > 0) {
      if (this.serverFilterObj && this.serverFilterObj.length > 0)
        filterObj.map((fObj) => {
          let objIndex = this.serverFilterObj.findIndex(function (obj) {
            return obj.filterColumn == fObj.filterColumn;
          });
          if (objIndex != -1) {
            this.serverFilterObj[objIndex] = fObj;
          } else {
            this.serverFilterObj.push(fObj);
          }
        });
      else {
        this.serverFilterObj = filterObj;
      }
    } else {
      if (this.serverFilterObj && this.serverFilterObj.length > 0) {
        let serverFilterObj = JSON.parse(JSON.stringify(this.serverFilterObj));
        serverFilterObj = this.serverFilterObj.filter((fObj) => {
          return fObj.filterColumn == 'any';
        });
        this.serverFilterObj = serverFilterObj;
      }
    }
    return this.serverFilterObj;
  }

  getById(id: number): Observable<ResponseData<SalesOrderModal>> {
    return this.http.get<ResponseData<any>>(environment.SERVER_URL + 'chemical/salesOrder/' + id);
  }
}
